export default [
  {
    path: "/ugg1RIKaeYHN1KK8PYPTVCTgo",
    children: [
      {
        path: "stat",
        name: "ListState",
        meta: {
          title: "States",
          authRequired: true,
          acc: ["y51656"],
        },
        component: () => import("@/views/states/index.vue"),
      },
      {
        path: "new",
        name: "CreateState",
        meta: {
          title: "Create State",
          authRequired: true,
          acc: ["y51656"],
        },
        component: () => import("@/views/states/new.vue"),
      },
      {
        path: ":lg/view",
        name: "ViewState",
        meta: {
          title: "View State",
          authRequired: true,
          acc: ["y51656"],
        },
        component: () => import("@/views/states/view.vue"),
      },
      {
        path: ":lg/edit",
        name: "EditState",
        meta: {
          title: "Edit States",
          authRequired: true,
          acc: ["y51656"],
        },
        component: () => import("@/views/states/edit.vue"),
      },
    ],
  },
];
